export default __webpack_public_path__ + "static/media/single-project-page-03-img05.baf81125.jpg";